import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export async function getSettings() { return (await api.get("/settings")).data; }
export async function joinWaitlist(payload) { return (await api.post("/waitlist", payload)).data; }
export async function submitRegistration(formData) {
  return (await api.post("/registrations", formData, { headers: { "Content-Type": "multipart/form-data" } })).data;
}
export async function authMe() { return (await api.get("/auth/me")).data; }
export async function authLogout() { return (await api.post("/auth/logout")).data; }
export async function exchangeSession(session_id) { return (await api.post("/auth/session", { session_id })).data; }

export async function adminMetrics() { return (await api.get("/admin/metrics")).data; }
export async function adminRegistrations(params={}) { return (await api.get("/admin/registrations", { params })).data; }
export async function adminUpdateReg(id, patch) { return (await api.patch(`/admin/registrations/${id}`, patch)).data; }
export async function adminWaitlist() { return (await api.get("/admin/waitlist")).data; }
export async function adminGetSettings() { return (await api.get("/admin/settings")).data; }
export async function adminUpdateSettings(body) { return (await api.put("/admin/settings", body)).data; }
export async function adminCheckin(id) { return (await api.post(`/admin/attendance/${id}/check-in`)).data; }
